<template>
  <div>
    <div class="row border-bottom border-danger pb-3">
      <div class="w-30 mr-3">
        <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="day" class="text-dark"></datepicker>
      </div>
      <div class="w-50">
        <button @click="getInvoices" class="btn btn-primary p-2">SEARCH <b-icon-search shift-h="3"></b-icon-search></button>
      </div>
    </div>

    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>

    <div class="row" v-if="invoices.length">
      <div class="w-100 mt-3 overflow-hidden rounded">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Name</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Number</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Value</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Status</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Excel</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in invoices" v-bind:key="i" class="pointer">
            <th @click="renderInvoice(row)" scope="row">{{moment(row.createdAt).format('DD.MM.yyyy HH:mm')}}</th>
            <td @click="renderInvoice(row)">{{row.client.name || "No name"}} {{row.desc ? ` - ${row.desc}` : ''}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.number}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.items.reduce((value, item) => value += item.qtt * item.price, 0).toFixed(2)}} kr</td>
            <td v-if="row.canceled" class="d-none d-sm-table-cell text-center text-danger">
              <b-button @click="getTripletexInvoice(row.kreditNote ? row.kreditNote : row.ttexId)">KREDITNOTA</b-button>
            </td>
            <td v-else class="d-none d-sm-table-cell text-center text-success">
              <b-button variant="success" @click="cancelInvoice(row._id, row.ttexId)">{{row.paid ? 'PAID POS' : 'TRIPLETEX'}}</b-button>
            </td>
            <td class="d-none d-sm-table-cell text-center">
              <b-button variant="info" @click="getExcelFile(row)">File</b-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      <div class="w-100 text-center mt-3">
        <h5>No invoices for selected day</h5>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

import fixed from '../../fixed';

export default {
  components: {
    Datepicker,
  },
  data: () => ({
    loading: false,
    invoices: [],
    day: moment(new Date()).format('yyyy-MM-DD'),
    moment,
  }),
  mounted() {
    this.getInvoices();
  },
  methods: {
    async getInvoices() {
      this.loading = true;
      try {
        const { data } = await axios.get(`${fixed.API_URL}/admin/invoices`, { withCredentials: true, params: { day: moment(this.day).format('yyyy-MM-DD') } });
        this.invoices = data || [];
      } catch (err) {
        this.$toast.error('can\'t fetch invoices');
      }
      this.loading = false;
    },
    async renderInvoice(invoice) {
      this.loading = true;

      try {
        const { data } = await axios.post(`${fixed.API_URL}/admin/otf-invoice`, invoice, { withCredentials: true, responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      } catch (err) {
        this.$toast.error('can\'t render invoice');
      }
      this.loading = false;
    },
    async getExcelFile(invoice) {
      this.loading = true;

      try {
        const response = await axios.post(`${fixed.API_URL}/admin/otf-excel`, invoice, { withCredentials: true, responseType: 'blob' });
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = invoice?.client?.name || 'price_analysis.xlsx';

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
      } catch (error) {
        this.$toast.error('can\'t download price analysis file');
      }

      this.loading = false;
    },
    async getTripletexInvoice(id) {
      if (!id) return;

      this.loading = true;
      try {
        const { data } = await axios.get(`${fixed.API_URL}/admin/tripletex-invoice/${id}`, { withCredentials: true, responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      } catch (err) {
        this.$toast.error('can\'t get Tripletex invoice');
      }
      this.loading = false;
    },
    async cancelInvoice(_id, ttexId) {
      const ok = confirm('Are you sure you want to cancel this invoice?'); // eslint-disable-line
      if (!ok) return;

      this.loading = true;
      try {
        await axios.put(`${fixed.API_URL}/admin/cancel-invoice`, { _id, ttexId }, { withCredentials: true });
        this.$toast.success('successfully created kreditnote');
        await this.getInvoices();
      } catch (err) {
        this.$$toast.error('can\'t cancel the invoice, check stock counts');
      }
    },
  },
};
</script>

<style>

</style>
